import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

export type IconType = 'solid' | 'regular' | 'light' | 'duotone' | 'brands' | 'thin';
export type IconSize = '2xs' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '';

@Component({
    selector: 'app-icon',
    imports: [],
    templateUrl: './icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() icon: string = '';
  @Input() type: IconType = 'regular';
  @Input() size: IconSize = '';
  
  get iconName(): string {
    const sizeName : string = `${this.size ? ' fa-' + this.size : ''}`;

    if (this.icon.includes('kit')) {
      return `${this.icon}${sizeName}`;
    }
    return `fa-${this.type} fa-${this.icon}${sizeName}`;
  }
}
